import React from 'react';
import { partnersData } from '../data/mock';

const Partners = () => {
  return (
    <section id="partners" className="py-16 lg:py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-10 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            Nuestras máquinas
          </h2>
        </div>

        {/* Partners Grid */}
        <div className="flex flex-wrap justify-center items-center gap-6 lg:gap-8">
          {partnersData.map((partner) => (
            <div
              key={partner.id}
              className="group flex items-center justify-center p-5 bg-gray-50 rounded-lg hover:bg-white hover:shadow-md border border-gray-100 hover:border-gray-200 transition-all duration-300 min-w-[130px]"
            >
              <img
                src={partner.logo}
                alt={partner.nombre}
                className="h-10 w-auto object-contain opacity-70 group-hover:opacity-100 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
